import { API_BASE_URL, API_PATHS, getApiPaths } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class AttendenceService {


  static getAttendence(item = {}) {
    const user = JSON.parse(localStorage.getItem("user"));
    const dynamicPaths = getApiPaths(user?.data?.roleId?.name);

    let api = `${API_BASE_URL}${dynamicPaths.getAttendence}`;
    const params = new URLSearchParams();

    if (item?.limit) params.append("limit", item.limit);
    if (item?.page) params.append("page", item.page);
    if (item?.id) params.append("id", item.id);
    if (item?.teacherId) params.append("teacherId", item.teacherId);
    if (item?.studentId) params.append("studentId", item.studentId);
    if (item?.standardId) params.append("standardId", item.standardId);
    if (item?.sectionId) params.append("sectionId", item.sectionId);
    if (item?.fromDate) params.append("fromDate", item.fromDate);
    if (item?.toDate) params.append("toDate", item.toDate);

    if ([...params].length > 0) {
      api += `?${params.toString()}`;
    }

    return axiosInstance.get(api);
  }



  static addAttendence(data) {
    const user = JSON.parse(localStorage.getItem("user"));
    const dynamicPaths = getApiPaths(user?.data?.roleId?.name);
    let api = '';
    api = `${API_BASE_URL}${dynamicPaths.addAttendence}`;
    return axiosInstance
      .post(api, data)
  }


}

export default AttendenceService;
